module.exports = __webpack_public_path__ + "static/media/caret-down-solid.2b5a68b4.svg";